import { Router } from '@angular/router';
import { SaldoService } from '../services/saldo.service';
import { ToastrService } from 'ngx-toastr';

export class SaldoUtil {

  static async validarAcessoSegmentacao(
    saldoService: SaldoService,
    router: Router,
    toastr: ToastrService
  ): Promise<boolean> {
    try {
      const saldo = await saldoService.obterSaldoAtual();
      
      if (saldo.quantidade > 0) {
        return true;
      }

      toastr.warning('Você não possui saldo suficiente para acessar a segmentação.');
      return false;

    } catch (error) {
      console.error('Erro ao verificar saldo:', error);
      toastr.error('Erro ao verificar saldo');
      return false;
    }
  }

  static async navegarParaSegmentacao(
    saldoService: SaldoService,
    router: Router,
    toastr: ToastrService,
  ): Promise<void> {
    const temAcesso = await this.validarAcessoSegmentacao(saldoService, router, toastr);
    
    if (temAcesso) {
      await router.navigate(['/area-logada/segmentacao']);
    }
  }
}